import { createContext, useContext, useLayoutEffect, useState } from "react";

const ThemeContext = createContext();

export const ThemeProvider = ({ children }) => {
  // 1. Initialize State
  const [theme, setTheme] = useState(() => {
    if (typeof window !== "undefined") {
      const saved = localStorage.getItem("cmp-theme-mode");
      // Check storage first. If it says 'light', TRUST IT.
      if (saved === "light") return "light";
      if (saved === "dark") return "dark";

      // Fallback to system
      return window.matchMedia("(prefers-color-scheme: dark)").matches
        ? "dark"
        : "light";
    }
    return "dark";
  });

  // 2. The Enforcer (useLayoutEffect runs BEFORE the screen paints)
  useLayoutEffect(() => {
    const root = window.document.documentElement;

    if (theme === "dark") {
      root.classList.add("dark");
      root.classList.remove("light"); // Just to be safe
    } else {
      root.classList.remove("dark");
      root.classList.add("light"); // Optional but helps some CSS frameworks
    }

    localStorage.setItem("cmp-theme-mode", theme);
  }, [theme]); // Runs whenever 'theme' changes

  const toggleTheme = () => {
    setTheme((prev) => (prev === "dark" ? "light" : "dark"));
  };

  return (
    <ThemeContext.Provider value={{ theme, toggleTheme }}>
      {children}
    </ThemeContext.Provider>
  );
};

// eslint-disable-next-line react-refresh/only-export-components
export const useTheme = () => useContext(ThemeContext);
